import * as React from "react";
import ActivityHeader from "@/components/ActivityHeader";

interface HeaderBarProps {
    connected?: boolean;
}

export default function HeaderBar({ connected = true }: HeaderBarProps) {
    return <ActivityHeader eyebrow="Vonix Integration" title="QQCatalyst" connected={connected} />;
}
